import { zones } from './json/countries.json';

function getCountryByTimeZone(timeZone: string) {
  const timezone_object = zones[timeZone as keyof typeof zones];

  if (
    !timezone_object ||
    !timezone_object.countries ||
    !timezone_object.countries.length
  ) {
    return 'UNK';
  }

  return timezone_object.countries[0] || 'UNK';
}

export function getBrowserInfo() {
  const language = navigator.language;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  let country = '';

  country = getCountryByTimeZone(timezone);

  return { language, timezone, country };
}

declare global {
  interface Window {
    Android?: any;
    webkit?: any;
    isNativeApp?: boolean;
    ReactNativeWebView?: { postMessage: (msg: string) => void };
  }
}

export type WindowWithNativeBridge = Window & {
  ReactNativeWebView: NonNullable<Window['ReactNativeWebView']>;
};

export function isRunningInNativeApp(
  win: Window | undefined = typeof window === 'undefined' ? undefined : window,
): win is WindowWithNativeBridge {
  return (
    win !== undefined &&
    typeof win.ReactNativeWebView?.postMessage === 'function'
  );
}

export function isRunningInIosNativeApp(
  win: Window | undefined = typeof window === 'undefined' ? undefined : window,
): boolean {
  if (!isRunningInNativeApp(win)) {
    return false;
  }

  const nav = win?.navigator;
  const ua = nav?.userAgent || '';

  // iPhone/iPod (e iPad quando a UA ainda expoe "iPad").
  if (/iP(hone|ad|od)/i.test(ua)) {
    return true;
  }

  // iPad: desde o iPadOS 13 o WKWebView manda, por padrao, a UA de Mac
  // (modo desktop) e NAO expoe "iPad" — por isso a deteccao so por UA
  // falhava no iPad. Detecta o iPad como "Macintosh com touch": um Mac
  // real reporta maxTouchPoints 0; o iPad reporta > 0.
  return /Macintosh/i.test(ua) && (nav?.maxTouchPoints ?? 0) > 0;
}

export function isRunningInPWA() {
  if (
    typeof window.Android !== 'undefined' ||
    typeof window.webkit !== 'undefined'
  ) {
    return true;
  }

  const ua = navigator.userAgent || '';

  if (ua.includes('wv') || ua.includes('WebView')) {
    return true;
  }

  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }

  return (window as any).isNativeApp === true;
}

export function isRunningInTWA() {
  return (
    document.referrer.includes('app_source=app&standalone=true') ||
    document.referrer.startsWith('android-app://')
  );
}
